import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=74b6c238&scoped=true"
import script from "./CartTotal.vue?vue&type=script&lang=js"
export * from "./CartTotal.vue?vue&type=script&lang=js"
import style0 from "./CartTotal.vue?vue&type=style&index=0&id=74b6c238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6c238",
  null
  
)

export default component.exports